// utils/jwt.js
function decodeBase64Json(b64) {
    try {
        // Клиент
        if (typeof atob === 'function') {
            const str = atob(b64);
            return JSON.parse(
                decodeURIComponent(
                    Array.prototype.map.call(str, c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
                )
            );
        }
    } catch (_) {}
    try {
        // SSR (Node)
        // eslint-disable-next-line no-undef
        const json = Buffer.from(b64, 'base64').toString('utf8');
        return JSON.parse(json);
    } catch (_) {
        return null;
    }
}

export function getJwtExpMs(token) {
    if (!token || token.split('.').length < 2) return null;
    try {
        const payloadB64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const payload = decodeBase64Json(payloadB64);
        return payload && typeof payload.exp === 'number' ? payload.exp * 1000 : null;
    } catch {
        return null;
    }
}

export function isJwtValid(token, { skewMs = 30000 } = {}) {
    const expMs = getJwtExpMs(token);
    return expMs ? Date.now() + skewMs < expMs : !!token;
}
